import React from "react";
import { TutorialProviderBase } from "./TutorialContext";
import TutorialHydrator from "./TutorialHydrator";
import TutorialOverlay from "./TutorialOverlay";

/**
 * Mount once inside AuthProvider and inside Router.
 *
 * Composes the context provider, the API bridge and the portal overlay without
 * creating a circular import between the modules. It lives in the
 * authenticated subtree so the overlay can call authFetch directly when a hint
 * is dismissed; mounting it above AuthProvider is what previously forced
 * dismissals through a queue that could be dropped.
 */
export const TutorialProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) =>
  React.createElement(
    TutorialProviderBase,
    null,
    React.createElement(TutorialHydrator),
    children,
    React.createElement(TutorialOverlay)
  );

export { useTutorialContext } from "./TutorialContext";
export {
  useTutorialTarget,
  useTutorialHint,
  useTutorial,
  useTutorialActions,
} from "./hooks";
export type {
  TutorialHintDef,
  TutorialTourDef,
  TutorialPlacement,
  TutorialScope,
} from "./types";
